import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  containerStyle: {
    borderTopLeftRadius: 6.2,
    borderTopRightRadius: 6.2,
    backgroundColor: Colors.ocean,
    paddingHorizontal: 16,
    paddingVertical: 4,
    alignSelf: 'baseline',
  },
  textStyle: {
    ...Fonts.type.bold,
    fontSize: 16.6,
    lineHeight: 22.9,
    color: Colors.white,
  },
});
